{
    "coordinates": [
        43.42382432953133,
        -103.48338094822556
    ],
    "tooltip": "Mammoth",
    "title": "The Mammoth Site",
    "country": "United States",
    "period": "Quaternary",
    "alt": "TODO"
}
